module.exports = __webpack_public_path__ + "static/ashley_sanders-1d78923675d86b2bec69f93eadc0eb0b.jpg";